export default "__VITE_ASSET__EcqRpqw1__"